module.exports = __webpack_public_path__ + "assets/money.b5b71baa.svg";